<select *ngIf="!custom_option" (change)="changeOption($event.target)">
	<option *ngFor="let option of options_array" [value]="option" [selected]="selected_option == option">{{ option }}</option>
	<option value="custom">Sonstiges</option>
</select>
<div *ngIf="custom_option" class="text-right">
	<input [(ngModel)]="custom_input" (input)=changeOption($event.target) type="text">
	<span (click)="loadDefault()" class="text-txt-small underline cursor-pointer">Standardwerte laden</span>
</div>